import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = {
  config: () => axios.get(`${API}/config`).then((r) => r.data),
  rooms: () => axios.get(`${API}/rooms`).then((r) => r.data.rooms),
  room: (id) => axios.get(`${API}/rooms/${id}`).then((r) => r.data),
  attractions: () => axios.get(`${API}/attractions`).then((r) => r.data.attractions),
  facilities: () => axios.get(`${API}/facilities`).then((r) => r.data.facilities),
  reviews: () => axios.get(`${API}/reviews`).then((r) => r.data.reviews),
  initiateBooking: (payload) => axios.post(`${API}/bookings/initiate`, payload).then((r) => r.data),
  confirmBooking: (payload) => axios.post(`${API}/bookings/confirm`, payload).then((r) => r.data),
  submitUtr: (payload) => axios.post(`${API}/bookings/submit-utr`, payload).then((r) => r.data),
  booking: (ref) => axios.get(`${API}/bookings/${ref}`).then((r) => r.data),
  contact: (payload) => axios.post(`${API}/contact`, payload).then((r) => r.data),
};
